import { memo, useContext } from 'react';
import styled from '@emotion/styled';

import { WWContext, type WWContextValue } from '../../../WWContext';
import { themeFont } from '../../../../lib/themeFont';
import useDateDisplayWithFormat, {
  TBD_MESSAGE,
} from '../../../../lib/useDateDisplayWithFormat';

import {
  DatePreference,
  isWwsWeddingWebsiteV2,
} from '../../../../types/graphql';

import type { ThemeProps } from '@emotion/react';
import type { CSSObject } from '@emotion/styled';

const Footer = styled("div")`
  min-height: 1vw;
  text-align: center;
  padding: 1rem;
  background: inherit;
  color: inherit;
  font-size: 1rem;

  ${themeFont('s6')}

  a:link {
    text-decoration: underline;
  }

  ${({ theme }: ThemeProps): CSSObject | undefined => theme.liteSite?.Footer}
`;

function LiteFooter() {
  const { data } = useContext<WWContextValue>(WWContext);

  const date = useDateDisplayWithFormat();

  if (!isWwsWeddingWebsiteV2(data?.weddingWebsiteResult)) {
    return null;
  }

  const dateDisplay =
    date === TBD_MESSAGE
      ? 'Wedding Day To Be Announced'
      : `Wedding Day on ${date}`;

  const hideDate =
    data?.weddingDatePreferences?.datePreference === DatePreference.Tba;

  const location =
    !hideDate && data?.weddingWebsiteResult.weddingLocation
      ? `in ${data.weddingWebsiteResult.weddingLocation}.`
      : '';

  return (
    <Footer data-testid="wedding-info">
      <p>
        {data?.weddingWebsiteResult.firstName || ''}{' '}
        {data?.weddingWebsiteResult.lastName || ''} &{' '}
        {data?.weddingWebsiteResult.fianceFirstName || ''}{' '}
        {data?.weddingWebsiteResult.fianceLastName || ''}&apos;s Wedding Website
        | Made with love on{' '}
        <a href="https://www.theknot.com/gs/wedding-websites">The Knot</a> |{' '}
        {dateDisplay} {location}
      </p>
      <a href="https://www.theknot.com/gs/wedding-websites">
        Create your own Free Wedding Website
      </a>{' '}
      on The Knot
    </Footer>
  );
}

export default memo(LiteFooter);
